import { giphyIndigo } from '@giphy/js-brand'
import React, { useContext, useRef, useState } from 'react'
import { useParams } from 'react-router'
import MessageContext from 'shared/components/context/message'
import CSRFToken from 'shared/components/form/csrftoken-hoc'
import {
    Content,
    CTAButton as BrandCTAButton,
    FormContainer,
    FormInput,
    Title,
} from 'shared/components/form/form-components'
import { assertIsDefined } from 'shared/types/asserts'
import styled from 'styled-components'

const CTAButton = styled(BrandCTAButton)`
    width: 100%;
`

const currentPassword = 'current_password'
const newPassword = 'new_password'
const newPasswordConfirm = 'new_password_confirm'

type Errors = {
    currentPassword?: string
    newPassword?: string
    newPasswordConfirm?: string
}
const PasswordResetForm = ({ csrftoken }) => {
    const form = useRef<HTMLFormElement | null>(null)
    const { token } = useParams()
    const showCurrentPassword = !token
    const [currentPasswordError, setCurrentPasswordError] = useState<Errors>({})
    const { sendMessage } = useContext(MessageContext)
    const submit = async e => {
        e.stopPropagation()
        e.preventDefault()
        assertIsDefined(form.current)
        const data = new FormData(form.current)
        let errors = {}
        if (showCurrentPassword && !data.get(currentPassword)) {
            errors = { ...errors, currentPassword: 'Required Field' }
        }
        if (!data.get(newPassword)) {
            errors = { ...errors, newPassword: 'Required Field' }
        }
        if (!data.get(newPasswordConfirm)) {
            errors = { ...errors, newPasswordConfirm: 'Required Field' }
        }
        if (Object.keys(errors).length === 0) {
            if (data.get(newPassword) !== data.get(newPasswordConfirm)) {
                sendMessage("New passwords don't match", 'error')
                return
            }
            form.current.submit()
        }
        setCurrentPasswordError(errors)
    }
    const onChange = () => {
        setCurrentPasswordError({})
    }
    const inputProps = { type: 'password', onChange }
    return (
        <FormContainer>
            <form onSubmit={submit} ref={form} method="post">
                {csrftoken && <input type="hidden" name="csrfmiddlewaretoken" value={csrftoken} />}
                {!showCurrentPassword && <input id="token" name="token" type="hidden" value={token} />}
                <Content>
                    <Title>
                        {showCurrentPassword ? `Change` : `Reset `} <br />
                        Password
                    </Title>
                    {showCurrentPassword && (
                        <FormInput
                            inputProps={{
                                autoComplete: 'current-password',
                                name: currentPassword,
                                placeholder: 'Current Password',
                                ...inputProps,
                            }}
                            errorMessage={currentPasswordError.currentPassword}
                        />
                    )}
                    <FormInput
                        inputProps={{
                            autoComplete: 'new-password',
                            name: newPassword,
                            placeholder: 'New Password',
                            ...inputProps,
                        }}
                        errorMessage={currentPasswordError.newPassword}
                    />
                    <FormInput
                        inputProps={{
                            autoComplete: 'new-password',
                            name: newPasswordConfirm,
                            placeholder: 'Confirm New Password',
                            ...inputProps,
                        }}
                        errorMessage={currentPasswordError.newPasswordConfirm}
                    />
                    <CTAButton color={giphyIndigo}>Save</CTAButton>
                </Content>
            </form>
        </FormContainer>
    )
}

export default CSRFToken(PasswordResetForm)
